<template>
  <el-image :fit="fit" :style="[style]" :initial-index="initialIndex" :preview-src-list="previewSrcListComputed"
            :src="src?loadImg(src,replacePx(width),replacePx(height),text,size):defaultSrc"
            :lazy="lazy" :data-index="dataIndex"></el-image>

</template>

<script>
import {loadImg} from "@/utils/fileUtils";

export default {
  name: "l-image",
  methods: {
    loadImg,
    replacePx(e) {
      if (e.indexOf('px') !== -1) {
        return e.replace('px', '')
      }
      return undefined
    }
  },
  computed: {
    style() {
      return {
        width: this.width,
        height: this.height,
        borderRadius: this.radius
      }
    },
    previewSrcListComputed() {
      return this.previewSrcList.map(item => loadImg(item))
    }
  },
  props: {
    // 确定图片如何适应容器框，同原生 object-fit
    fit: {
      type: String,
      default: "fill"
    },
    // 宽度
    width: {
      type: String,
      default: "auto"
    },
    // 是否懒加载
    lazy: {
      type: Boolean,
      default: true
    },
    // 圆角
    radius: {
      type: String,
      default: '0px'
    },
    // 高度
    height: {
      type: String,
      default: "auto"
    },
    // 图片地址
    src: {
      type: String,
      default: ""
    },
    // 默认图片
    defaultSrc: {
      type: String,
      default: require('@/assets/image/logo2.png')
    },
    // 水印文字
    text: {
      type: String,
    },
    size: {
      type: Number,
      default: 10
    },
    previewSrcList: {
      type: Array,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    dataIndex: {}
  }
}
</script>


<style scoped lang="scss">
::v-deep.el-image {
  vertical-align: top;
}
</style>